import { createTermTagManager } from '../../utils/createTermTagManager';

export const newbuildingCompletedTagManager = createTermTagManager({
  jsonQueryKey: 'hand_over',
  label: 'Дом сдан',
  id: 'newbuildingCompleted',
});
